import API from "@/api/lib/api";

export const getAllDrinks = async (restaurant_id) => {
  try {
    const response = await API.get(`restaurant/${restaurant_id}/drinks`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleDrink = async (item_id) => {
  try {
    const response = await API.get(`restaurant/drinks/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createDrink = async (data) => {
  try {
    const response = await API.post(`restaurant/drinks`, data);
    return response.data;
  } catch (error) {
    console.error("Error creating drink:", error);
    return {
      status: "failure",
      message: error.response?.data.message || "Something went wrong.",
    };
  }
};

export const updateDrink = async (item_id, data) => {
  try {
    const response = await API.put(`restaurant/drinks/${item_id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating drink:", error);
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const websiteOrderingAvailableItemsToggle = async (id, type, toggleAvailabilityType) => {
  
  try {
    const response = await API.put(
      `restaurant/${type}/${id}/toggle-availability`,
      {
        availability_type: toggleAvailabilityType,
      }
    );
    return response.data;
  } catch (error) {    
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
export const qrCodeOrderingAvailableItemsToggle = async (id, type) => {
  try {
    const response = await API.put(
      `restaurant/${type}/${id}/toggle-availability`,
      {
        availability_type: 'qr_code',
      }
    );
    return response.data;
  } catch (error) {    
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteDrink = async (item_id) => {
  try {
    const response = await API.delete(`restaurant/drinks/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
